import { render, staticRenderFns } from "./ManageCorrespondenceView.vue?vue&type=template&id=653388a8"
import script from "./ManageCorrespondenceView.vue?vue&type=script&lang=js"
export * from "./ManageCorrespondenceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports